import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that redirects legacy room paths to their static HTML versions
 * Example: /cinema -> /cinema/index.html
 */
function LegacyRoomRedirect() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    // Don't redirect if already has .html
    if (path.includes('.html')) {
      return;
    }

    // Redirect to index.html version
    const redirectPath = path.endsWith('/')
      ? `${path}index.html`
      : `${path}/index.html`;

    console.log(`Redirecting legacy room: ${path} -> ${redirectPath}`);
    window.location.href = redirectPath;
  }, [location]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      background: '#000',
      color: '#fff'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Loading room...</h2>
      </div>
    </div>
  );
}

export default LegacyRoomRedirect;
